import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { ComplianceService } from '../compliance.service';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';

export interface ComplianceReturnAddOutputParameters {
    filingBatchId: number;
    companyId: number;
}

export interface ComplianceReturnAddParameters {
    filingId: number;
    priorFilings: Compliance.FilingModel[];
}

@Component({
    templateUrl: './return-add.component.html',
    selector: 'compliance-return-add',
    standalone: false
})
export class ComplianceReturnAddComponent implements OnInit, IWeissmanModalComponent<ComplianceReturnAddParameters, ComplianceReturnAddOutputParameters> {
    constructor(
        private readonly _complianceService: ComplianceService,
        private readonly _bsModalRef: BsModalRef) {
    }

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();
    filingId: number;
    params: ComplianceReturnAddParameters;
    result: ComplianceReturnAddOutputParameters;
    priorFilings: Compliance.FilingModel[];
    priorFiling: Compliance.FilingModel = null;
    isAmendment: boolean = false;
    isInitialized: boolean = false;
    priorReturnSelected: boolean;

    async ngOnInit(): Promise<void> {
        this.filingId = this.params.filingId;
        this.priorFilings = this.params.priorFilings;

        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading', busyMsgId);

        try {
            // in case the filing batch has already been created close
            const filing = await this._complianceService.getFiling(this.filingId);
            if (filing.filingBatchId) {
                this.result = {
                    filingBatchId: filing.filingBatchId,
                    companyId: filing.topLevelCompanyId
                };
                this._bsModalRef.hide();
            }

            this.priorFiling = this.priorFilings.length ? this.priorFilings[0] : null;
            this.priorReturnSelected = this.priorFiling !== null;
            this.isAmendment = this.priorFiling ? this.priorFiling.isAmendment : false;
            this.isInitialized = true;
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    async save(): Promise<void> {
        const busyMsgId = 'saving';
        this.busyIndicatorMessageManager.add('Saving', busyMsgId);

        const updateModel: Compliance.FilingReturnUpdateModel = {
            filingId: this.filingId,
            priorReturnId: this.priorFiling && this.priorFiling.returnId,
            isAmendment: this.isAmendment
        };

        try {
            const filingBatch = await this._complianceService.createFilingBatch(updateModel);
            this.result = {
                filingBatchId: filingBatch.filingBatchId,
                companyId: filingBatch.companyId
            };

            this._bsModalRef.hide();
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }

    priorReturnChanged(): void {
        this.priorReturnSelected = this.priorFiling !== null;

        if (!this.priorReturnSelected) {
            this.isAmendment = false;
        }
    }
}
